import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        defaultListingPrice: 300000,
        // defaultDownPaymentAmount: 0,
        // loanOptions: {},
        propertyTax: 0,
        homeInsurance: 0,
        hoa: 0
    },
    mutations: {
        setDefaultListingPrice(state, payload) {
            state.defaultListingPrice = payload;
        },
        // setDefaultDownPaymentAmount(state, payload) {
        //     state.defaultDownPaymentAmount = payload;
        // },
        setPropertyTax(state, payload) {
            state.propertyTax = payload;
        },
        setHomeInsurance(state, payload) {
            state.homeInsurance = payload;
        },
        setHoa(state, payload) {
            state.hoa = payload;
        },
    },
    actions: {},
    getters: {},
});